import { SharedData } from '@models/shareddata';
import { FormatHelper } from '@services/public_api';

enum DayOfWeek {
  Zondag = 0,
  Maandag = 1,
  Dinsdag = 2,
  Woensdag = 3,
  Donderdag = 4,
  Vrijdag = 5,
  Zaterdag = 6,
}

enum Month {
  Januari = 0,
  Februari = 1,
  Maart = 2,
  April = 3,
  Mei = 4,
  Juni = 5,
  Juli = 6,
  Augustus = 7,
  September = 8,
  Oktober = 9,
  November = 10,
  December = 11
}

export class ComingDaysDateMapper {
  static transformComingDaysToDate(startDate: Date, titel: string, openingstijden: SharedData[]): Date {
    if (startDate == null || titel == null) {
      return null;
    }
    let days = this.getDaysFromPlaceholder(titel);
    return this.addDaysAndSkipWeekendsAndFeestdagen(startDate, days, openingstijden);
  }

  static transformComingDaysToDateString(startDate: Date, titel: string, openingstijden: SharedData[]): string {
    if (startDate == null || titel == null) {
      return null;
    }
    return this.visualizeDate(this.transformComingDaysToDate(startDate, titel, openingstijden));
  }

  private static addDaysAndSkipWeekendsAndFeestdagen(date: Date, days: number, openingstijden: SharedData[]): Date {
    let daysCounter = 0;
    while (daysCounter < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();

      if (day != DayOfWeek.Zaterdag &&
        day != DayOfWeek.Zondag &&
        (openingstijden == null || !this.isFeestdag(date, openingstijden)))
        daysCounter++;
    }

    return date;
  }

  private static isFeestdag(datum: Date, openingstijden: SharedData[]): boolean {
    const jmd = FormatHelper.formatDate(datum, 'yyyy-MM-dd');
    return openingstijden.some(sd => sd.Name.startsWith('Feestdag') && sd.Phrase === jmd);
  }

  private static visualizeDate(date: Date): string {
    return `${this.mapDayToString(date.getDay())} ${date.getDate()} ${this.mapMonthToString(date.getMonth())}`;
  }

  private static mapDayToString(day: number): string {
    return DayOfWeek[day];
  }

  private static mapMonthToString(month: number): string {
    return Month[month].toLowerCase();
  }

  private static getDaysFromPlaceholder(placeholder: string): number {
    const matches = placeholder.match(/^\{datum\+(\d*)\}$/);
    return matches?.length != 2 ? 0 : +matches[1];
  }
}
